import { render, staticRenderFns } from "./countTo.vue?vue&type=template&id=4620a92a&scoped=true"
import script from "./countTo.vue?vue&type=script&lang=js"
export * from "./countTo.vue?vue&type=script&lang=js"
import style0 from "./countTo.vue?vue&type=style&index=0&id=4620a92a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4620a92a",
  null
  
)

export default component.exports